import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../../types/types';
import { ICardCommentsEvents, ICardCommentsFields } from '../../components/CommentsSection/types';
import {
    getAuthUserSettingsCommentsSort
} from '../../../../../../../store/model/authUser/selectors/getAuthUserSettingsCommentsSort';
import { CommentsSection } from '../../components/CommentsSection/CommentsSection';
import { ICommentsSectionHOCProps } from './types';
import { getCardComments } from '../../../../../../../store/model/selectors/getCardComments';
import { EUserSettingsCommentSort } from '../../../../../../../types/rest/IRestAuthUser';
import { getBoardPermissions } from '../../../../../../../store/model/selectors/getBoardPermissions';
import {
    getBoardIsCardDefaultProperty
} from '../../../../../../../store/model/board/selectors/getBoardIsCardDefaultProperty';
import { EAsidePanelProperty } from '../../../../asidePanel/components/AsidePanel/types';
import { getSectionType } from '../../../selectors/getSectionType';
import {
    getIsNewFeaturePasteCommentAttachment
} from '../../../../../../../store/model/authUser/selectors/featuresSeen/getIsNewFeaturePasteCommentAttachment';
import { onHideTips } from './events/onHideTips';
import { getUserCommentsColumnView } from 'app/store/model/authUser/selectors/getUserCommentsColumnView';
import { getCardAssignees } from '../../../../../../../store/model/selectors/getCardAssignees';
import { getSortedCommentsCreateSelector } from '../../../../../base/components/Comments/selectors/getSortedComments';
import { onEdit } from './events/onEdit';
import { getCard } from '../../../../../../../store/model/selectors/getCard';
import { onLoad } from './events/onLoad';
import { onResetUnseen } from './events/onResetUnseen';

const mapStateToProps = () => {
    const getSortedComments = getSortedCommentsCreateSelector();

    const _mapStateToProps = (
        state: IApplicationState,
        ownProps: ICommentsSectionHOCProps
    ): ICardCommentsFields => {
        const sort = getAuthUserSettingsCommentsSort(state);
        const {cardId, boardId} = ownProps;
        const { authPermissions: { allowComment, allowEdit } } = getBoardPermissions(state, boardId);
        const sectionType = getSectionType(state, boardId, cardId, null, null, 'allowComment');
        const isShow = !allowEdit && allowComment || // если можно только комментировать, то всегда видно
            getUserCommentsColumnView(state) || // KNB-4083
            getCardComments(state, cardId).length > 0;
        const { commentCount } = getCard(state, cardId);
        return {
            assigneesCount: getCardAssignees(state, cardId).length,
            isDefaultProperty: getBoardIsCardDefaultProperty(state, boardId, EAsidePanelProperty.CARD_COMMENTS),
            comments: getSortedComments(state, cardId),
            commentCount,
            isShow,
            isShowTips: getIsNewFeaturePasteCommentAttachment(state),
            descOrder: sort === EUserSettingsCommentSort.DESC,
            cardId,
            boardId,
            sectionType
        };
    };

    return _mapStateToProps;
}

const mapDispatchToProps = (
    dispatch: any,
    { cardId }: ICommentsSectionHOCProps,
): ICardCommentsEvents => {
    return {
        onEdit: () => dispatch(onEdit()),
        onHideTips: () => dispatch(onHideTips()),
        onLoad: () => dispatch(onLoad(cardId)),
        onResetUnseen: () => dispatch(onResetUnseen(cardId)),
    };
};

export const CommentsSectionHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CommentsSection);

CommentsSectionHOC.displayName = 'CommentsSectionHOC';
